import { render } from "./ModalEditPlano.vue?vue&type=template&id=54b96ace"
import script from "./ModalEditPlano.vue?vue&type=script&lang=js"
export * from "./ModalEditPlano.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__